export const NetworkBadge = ({ className = "" }) => (
    <span
        data-testid="network-badge"
        className={`inline-flex items-center gap-3 border border-white/10 bg-[#07111F]/80 px-4 py-2.5 font-mono text-[10px] uppercase tracking-[0.24em] text-mute ${className}`}
    >
        <span className="relative flex h-2 w-2" aria-hidden="true">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#31D8FF] opacity-60" />
            <span className="relative inline-flex h-2 w-2 rounded-full bg-[#31D8FF]" />
        </span>
        ARC MAINNET · CHAIN 5042 · USDC SETTLEMENT
    </span>
);

export default NetworkBadge;
